module.exports = __webpack_public_path__ + "static/img/sciserver-notebook-loading.e14a883.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sciserver-notebook-loading.gif
// module id = FbNc
// module chunks = 1